import { z } from 'zod';

export const activationRequestSchema = z.object({
  id: z.string().uuid(),
  licenseId: z.string().uuid(),
  serial: z.string(),
  installationId: z.string(),
  clientVersion: z.string().nullable(),
  // `transfer_pending` (#178 fingerprint-identity auto-activation): a new hardware
  // fingerprint applied with the seat budget exhausted — the only operator-gated
  // status. `pending` is kept for the legacy flow DTO; the server emits
  // `issued | transfer_pending | rejected`.
  status: z.enum(['pending', 'issued', 'rejected', 'transfer_pending']),
  reviewedBy: z.string().nullable(),
  reviewedAt: z.string().nullable(),
  createdAt: z.string(),
});

export const activationRequestListSchema = z.object({
  data: z.array(activationRequestSchema),
});

export type ActivationRequest = z.infer<typeof activationRequestSchema>;
export type ActivationRequestList = z.infer<typeof activationRequestListSchema>;
